// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-tactical-outlaw-sling-pack-molle-multifunctional-day-bag",
  "entries": [
    {
      "id": "24115811319998",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Tactical-Outlaw-Sling-Pack-Molle-Multifunctional-Day-Bag-Seibertron-24115811319998.jpg?v=1769482878",
      "alt": "tactical sling backpack"
    },
    {
      "id": "31065550422206",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Tactical-Outlaw-Sling-Pack-Molle-Multifunctional-Day-Bag-Seibertron-31065550422206.png?v=1769482878",
      "alt": "sling tactical bag"
    },
    {
      "id": "31065545113790",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Tactical-Outlaw-Sling-Pack-Molle-Multifunctional-Day-Bag-Seibertron-31065545113790.jpg?v=1769482878",
      "alt": "sling backpack tactical"
    },
    {
      "id": "31065545179326",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Tactical-Outlaw-Sling-Pack-Molle-Multifunctional-Day-Bag-Seibertron-31065545179326.jpg?v=1769482878",
      "alt": "sling tactical"
    },
    {
      "id": "31065545212094",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Tactical-Outlaw-Sling-Pack-Molle-Multifunctional-Day-Bag-Seibertron-31065545212094.jpg?v=1769482890",
      "alt": "best tactical rifle sling"
    },
    {
      "id": "31065545081022",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Tactical-Outlaw-Sling-Pack-Molle-Multifunctional-Day-Bag-Seibertron-31065545081022.jpg?v=1769482890",
      "alt": "Seibertron Tactical Outlaw Sling Pack Molle Multifunctional Day Bag - Seibertron"
    },
    {
      "id": "24115812401342",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/products/Seibertron-Tactical-Outlaw-Sling-Pack-Molle-Multifunctional-Day-Bag-Seibertron-24115812401342.jpg?v=1769482890",
      "alt": "Seibertron Tactical Outlaw Sling Pack Molle Multifunctional Day Bag - SeibertronSports602201113123"
    },
    {
      "id": "31065545146558",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Tactical-Outlaw-Sling-Pack-Molle-Multifunctional-Day-Bag-Seibertron-31065545146558.jpg?v=1769482891",
      "alt": "sling tactical bags"
    }
  ],
  "variants": [
    {
      "id": "41897960046782",
      "title": "Black",
      "availableForSale": true,
      "values": [
        "Black"
      ],
      "mediaId": "24115811319998"
    },
    {
      "id": "41897960079550",
      "title": "Khaki",
      "availableForSale": true,
      "values": [
        "Khaki"
      ],
      "mediaId": "24115812401342"
    }
  ]
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncPurchase(scope);
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
})();
// END motorbikeBackpackGalleryRestore20260716
